// extracted by mini-css-extract-plugin
export default {"container":"our_work_container__jXjGg","title":"our_work_title__MsF9m","works_container":"our_work_works_container__6xvEu","work_item":"our_work_work_item__ERu3h"};